import React, { useEffect } from 'react'
import OfferCalendarDatePickerSelectBox from './OfferCalendarDatePickerSelectBox'
import OfferFullSizeFilterDropdown from '../OfferFilterFullSizeDropdown'
import OfferCalendarDatePicker from './OfferCalendarDatePicker'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'

interface Props {
  open: boolean;
  offsetDropdown?: boolean;
  useRooms?: boolean;
  defaultDayPicker?: boolean;
  defaultMonth?: string;
  onClickLabel: string;
}

function OfferCalendarDatePickerSelect(props: Props) {
  const {
    open,
    offsetDropdown,
    useRooms,
    defaultDayPicker,
    defaultMonth,
    onClickLabel,
  } = props

  const dispatch = useOfferPageDispatch()
  useEffect(() => {
    if (!open) {
      dispatch({ type: OfferPageActions.hideRecommendationsView })
    }
  }, [dispatch, open])

  return (<div>
    <OfferCalendarDatePickerSelectBox
      onClickLabel={onClickLabel}
    />
    <OfferFullSizeFilterDropdown
      open={open}
      offset={offsetDropdown}
      data-testid="offer-checkin-select"
    >
      <OfferCalendarDatePicker
        calendarOpen={open}
        defaultDayPicker={defaultDayPicker}
        defaultMonth={defaultMonth}
        useRooms={useRooms}
      />
    </OfferFullSizeFilterDropdown>
  </div>
  )
}

export default withOfferPageState(state => ({
  open: state.activeFilter === 'checkin',
}))(OfferCalendarDatePickerSelect)
